import React from 'react';

import { Box } from '@metarouter-private/mr-mui';

import PipelineOverviewStaticTable from 'app/pipeline-details/shared/PipelineOverviewStaticTable';

import useAnalyticsFileTable from './useAnalyticsFileTable';
import EndpointUrlsAccordion from './EndpointUrlsAccordion';

// Box with sx is required here — need to target child MuiPaper-root to remove
// bottom border-radius so the table connects flush with the accordion below it.
const CONNECTED_TABLE_STYLES = {
  '& > .MuiPaper-root': {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: 0,
  },
};

export default function AnalyticsFileTable() {
  const { tableProps, endpointUrls } = useAnalyticsFileTable();
  const hasEndpointUrls = endpointUrls.length > 0;

  return (
    <Box sx={hasEndpointUrls ? CONNECTED_TABLE_STYLES : null}>
      <PipelineOverviewStaticTable {...tableProps} />
      <EndpointUrlsAccordion endpointUrls={endpointUrls} />
    </Box>
  );
}
